module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.invoices), function(inv, i) {
    return _c('div', {
      staticClass: "tile ClientPayment"
    }, [_c('div', {
      staticClass: "tile-content"
    }, [_c('span', {
      staticClass: "tile-title c-hand",
      on: {
        "click": function($event) {
          return _vm.setInv(inv)
        }
      }
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-2"
    }, [_vm._v(_vm._s(inv.ref))]), _vm._v(" "), _c('div', {
      staticClass: "column col-2"
    }, [_vm._v(_vm._s(_vm.date(inv.date)))]), _vm._v(" "), _c('div', {
      staticClass: "column col-4"
    }, [_vm._v(_vm._s(inv.matter_desc))]), _vm._v(" "), _c('div', {
      staticClass: "column col-1 col-ml-auto"
    }, [_c('div', {
      staticClass: "tile-icon"
    }, [(inv.paid) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Paid")]) : _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Unpaid")])])])])])]), _vm._v(" "), (_vm.sel_inv === inv) ? _c('div', [_c('table', {
      staticClass: "table"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [_vm._l((inv.items), function(item) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))])])
    }), _vm._v(" "), (inv.gst) ? _c('tr', [_c('td', [_vm._v("GST (10%)")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.gst)))])]) : _vm._e(), _vm._v(" "), (inv.surcharge) ? _c('tr', [_c('td', [_vm._v("Surcharge (1.4%)")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.surcharge)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(inv.total)))])]), _vm._v(" "), (!inv.paid) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [(_vm.showPayBtn) ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.showPay = true
        }
      }
    }, [_vm._v("Pay")]) : _vm._e()])]) : _vm._e()], 2)]), _vm._v(" "), (inv.plan) ? _c('div', {
      staticClass: "paymentPlanTable"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_vm._m(2, true), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Monthly payment amount: $" + _vm._s(_vm.c2d(inv.monthly)))]), _vm._v(" "), _c('th', [_vm._v("Remaining: $" + _vm._s(_vm.c2d(inv.outstanding)))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._m(3, true)]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments(inv)), function(payment) {
      return _c('tr', [(inv.last_payment) ? _c('td', [_vm._v(_vm._s(payment.date))]) : _c('td', [_vm._v("Upcoming")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(payment.amount)))]), _vm._v(" "), _c('td', [(payment.paid) ? _c('span', {
        staticClass: "label label-rounded label-success"
      }, [_vm._v("Paid")]) : _c('span', {
        staticClass: "label label-rounded label-warning"
      }, [_vm._v("Scheduled")])])])
    }), 0)])]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('payment', {
    attrs: {
      "invoice": _vm.sel_inv,
      "active": _vm.showPay
    },
    on: {
      "hide": function($event) {
        _vm.showPay = false
      },
      "payment": _vm.getInvoices
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-2 text-bold"
  }, [_vm._v("\n        Reference\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 text-bold"
  }, [_vm._v("\n        Date\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4 text-bold"
  }, [_vm._v("\n        Description\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-1 col-ml-auto text-bold"
  }, [_vm._v("\n        Status\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Item description")]), _vm._v(" "), _c('th', [_vm._v("Cost")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h4', [_vm._v("Your payment plan")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Monthly amount")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c81d459a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/clientInvoices.vue
// module id = 520
// module chunks = 1